import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useMutation, UseMutationResult } from 'react-query';

export const useManualWireBankAccountConnect = (): UseMutationResult<
  any,
  any,
  any
> => {
  const { treasureApi } = useTreasureApi(ApiKeys.Banking);

  const manualWireBankAccountConnect = async ({
    accountNumber,
    accountType,
    bankName,
    wireRoutingNumber,
  }: {
    accountNumber: number;
    accountType: string;
    bankName: string;
    wireRoutingNumber: number;
  }) => {
    const { data } = await treasureApi().post('/accounts/manual-connect-wire', {
      accountNumber,
      accountType,
      bankName,
      wireRoutingNumber,
    });

    return data;
  };

  return useMutation(manualWireBankAccountConnect);
};
